import ConstructionIcon from '@mui/icons-material/Construction';
import EventIcon from '@mui/icons-material/Event';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { FunctionComponent, PropsWithChildren } from 'react';
import './L3ServiceMarkerContainer.css';

interface Props {
  displayNotificationsIcon?: boolean;
  displayActiveMaintenanceWorksIcon?: boolean;
  displayPlannedMaintenanceWorksIcon?: boolean;
}

export const L3ServiceMarkerContainer: FunctionComponent<PropsWithChildren<Props>> = ({
  children,
  displayPlannedMaintenanceWorksIcon,
  displayNotificationsIcon,
  displayActiveMaintenanceWorksIcon,
}) => {
  return <div className="marker-container">
    <div className="pin-container">
      {children}
    </div>
    <div className="actions-container">
      {displayNotificationsIcon
        ? <div>
          <button
            className="notifications"
            type="button"
          >
            <NotificationsNoneIcon fontSize={'small'} sx={{ width: '1rem', height: '1rem' }} />
          </button>
        </div>
        : null}
      {displayActiveMaintenanceWorksIcon
        ? <div>
          <button
            className="active-maintenance-works"
            type="button"
          >
            <ConstructionIcon fontSize={'small'} sx={{ width: '1rem', height: '1rem' }} />
          </button>
        </div>
        : null}
      {displayPlannedMaintenanceWorksIcon
        ? <div>
          <button
            className="planned-maintenance-works"
            type="button"
          >
            <EventIcon
              fontSize={'small'}
              sx={{ width: '1rem', height: '1rem' }}
            />
          </button>
        </div>
        : null}
    </div>
  </div>;
};
